Service = App.loadClass 'core::Angular/Service'

exports.register = (module) ->
    module.service 'Core.Services.Map', [exports.Map]


class exports.Map extends Service
    map: null
    L: null
    layers: {}

    constructor: (@L) ->
        if not @L?
            @L = window.L

        if App.map?
            @map = App.map

    createMap: () ->
        undefined

    getLeaflet: () ->
        return @L

    createFeatureGroup: (layers = []) ->
        return @L.featureGroup(layers)


    centerOn: (feature) =>
        if feature.getBounds?
            bounds = feature.getBounds()
        else
            bounds = feature

        @map.fitBounds(bounds)


    add: (feature, map = null, name = null) ->
        if not map?
            map = @map

        map.addLayer(feature)

        if name?
            @layers[name] = { feature: feature, added_to: map }

    remove: (feature, map = null) ->
        if not map?
            map = @map

        map.removeLayer(feature)

    removeByName: (name) =>
        if @layers[name]?
            @layers[name].added_to.removeLayer(@layers[name].feature)

            delete @layers[name]

    getByName: (name) =>
        if @layers[name]?
            return @layers[name]
